export default __webpack_public_path__ + "static/media/vietnamese_iced_coffee_thumbnail.e3439f27.JPG";